import React from 'react';

const items = [
    {
        icon: 'bx-target-lock',
        titulo: 'Misión',
        texto: 'Impulsar la presencia digital de nuestros clientes con soluciones web innovadoras, funcionales y de alto impacto que generen resultados tangibles para sus negocios.',
    },
    {
        icon: 'bx-show',
        titulo: 'Visión',
        texto: 'Ser referentes en desarrollo web en Paraguay y la región, destacando por creatividad, profesionalismo y compromiso con la excelencia en cada proyecto.',
    },
    {
        icon: 'bx-diamond',
        titulo: 'Valores',
        texto: 'Excelencia, innovación, compromiso y adaptabilidad. Cuatro principios que guían nuestra forma de trabajar y entregar resultados.',
    },
];

function Slider() {
    return (
        <section className="ds-section ds-section--mvv">
            <div className="ds-section-bg"></div>
            <div className="container py-5 position-relative">
                <div className="row justify-content-center text-center mb-5">
                    <div className="col-10 col-md-8">
                        <span className="ds-eyebrow">Filosofía</span>
                        <h2 className="text-white mt-2 mb-0 ds-titulo">
                            Lo que nos <span className="ds-highlight">mueve</span>
                        </h2>
                    </div>
                </div>
                <div className="row justify-content-center g-4">
                    {items.map((item, idx) => (
                        <div key={item.titulo} className="col-10 col-md-6 col-lg-4 d-flex">
                            <div className="ds-mini-card" style={{ animationDelay: `${idx * 120}ms` }}>
                                <div className="ds-mini-card-grid"></div>
                                <div className="ds-mini-card-glow"></div>
                                <div className="ds-mini-card-content">
                                    <div className="ds-mini-card-icon">
                                        <i className={`bx ${item.icon}`}></i>
                                    </div>
                                    <h4 className="ds-mini-card-title">{item.titulo}</h4>
                                    <p className="ds-mini-card-text">{item.texto}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Slider;
